import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=c90f27a0&scoped=true"
import script from "./CitySelect.vue?vue&type=script&lang=js"
export * from "./CitySelect.vue?vue&type=script&lang=js"
import style0 from "./CitySelect.vue?vue&type=style&index=0&id=c90f27a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f27a0",
  null
  
)

export default component.exports